import { useQuery } from '@tanstack/react-query';

import { APP_EXCLUSIVE_BRAND, APP_EXCLUSIVE_SCHEDULE_TYPE } from '~/consts/appExclusive';

import OffersService, { ScheduleRecord } from '~/services/OffersService';

// svc-offer defaults to 300; a padded month for one region is ~30 rows, so this leaves headroom.
const SCHEDULE_SEARCH_LIMIT = 500;

export interface AppExclusiveScheduleFilters {
  region: string;
  start: string;
  end: string;
}

export const appExclusiveScheduleQueryKeys = {
  all: ['schedules', APP_EXCLUSIVE_SCHEDULE_TYPE] as const,
  lists: () => [...appExclusiveScheduleQueryKeys.all, 'list'] as const,
  list: (filters: AppExclusiveScheduleFilters) => [...appExclusiveScheduleQueryKeys.lists(), filters] as const,
};

export function useGetAppExclusiveSchedules(filters: AppExclusiveScheduleFilters) {
  return useQuery({
    queryKey: appExclusiveScheduleQueryKeys.list(filters),
    queryFn: async ({ signal }): Promise<Array<ScheduleRecord>> =>
      OffersService.searchSchedules(
        {
          type: APP_EXCLUSIVE_SCHEDULE_TYPE,
          brand: APP_EXCLUSIVE_BRAND,
          region: filters.region,
          start: filters.start,
          end: filters.end,
          // A row longer than one slot blocks every day it touches, so fetch rows that only partly
          // overlap the grid too.
          overlaps: true,
          limit: SCHEDULE_SEARCH_LIMIT,
        },
        { signal },
      ),
    enabled: !!filters.region,
  });
}
